/* eslint-disable react/no-unknown-property */
/* eslint-disable @scandipwa/scandipwa-guidelines/only-render-in-component */
import ChooseLanguageSelector from 'Component/ChooseLanguageSelector';
import CmsBlock from 'Component/CmsBlock';
import ExpandableContent from 'Component/ExpandableContent';
import Subscription from 'Component/Subscription';
import SubscriptionBlockForm from 'Component/SubscriptionBlockForm';
import { TYPE_PRODUCT } from 'Route/UrlRewrites/UrlRewrites.config';
import { Footer as SourceFooter } from 'SourceComponent/Footer/Footer.component';
import history from 'Util/History';
import getStore from 'Util/Store';

/**
 * Cms Footer
 * @class Footer
 * @namespace Scandipwa/Component/Footer/Component */
export class FooterComponent extends SourceFooter {
    customComponents = {
        'Footer-Newsletter': this.renderNewsletter,
        'Footer-ExpandableContent': this.renderExpandableContent,
        'Footer-StoreSwitcher': this.renderStoreSwitcher,
        'Footer-Year': this.renderYear
    };

    state = {
        isVisible: true,
        isPDP: false,
        footerBlockLoading: false
    };

    excludedPages = ['/cart'];

    componentDidMount() {
        history.listen(() => this.onRouteChanged());
        this.setIsVisible();
    }

    componentDidUpdate(prevProps) {
        const { isFooterBootomSpaceNeeded } = this.props;
        const { isFooterBootomSpaceNeeded: prevIsFooterBootomSpaceNeeded } = prevProps;

        if (isFooterBootomSpaceNeeded !== prevIsFooterBootomSpaceNeeded) {
            this.setIsPDP();
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { isVisible: nextIsVisible } = nextState;
        const { isVisible: prevIsVisible } = this.state;

        const {
            device: {
                isMobile
            },
            isVisibleOnMobile,
            copyright,
            newsletterActive,
            isLoading
        } = this.props;

        const {
            device: {
                isMobile: nextIsMobile
            },
            isVisibleOnMobile: nextIsVisibleOnMobile,
            copyright: nextCopyright,
            newsletterActive: nextNewsletterActive,
            isLoading: nextIsLoading
        } = nextProps;

        return isMobile !== nextIsMobile
            || isVisibleOnMobile !== nextIsVisibleOnMobile
            || copyright !== nextCopyright
            || newsletterActive !== nextNewsletterActive
            || prevIsVisible !== nextIsVisible
            || isLoading !== nextIsLoading;
    }

    handleLoading = (isLoading) => {
        this.setState({ footerBlockLoading: isLoading });
    };

    onRouteChanged() {
        this.setIsVisible();
    }

    setIsVisible() {
        const { location: { pathname } } = history;
        const isVisible = !this.excludedPages.find((page) => pathname.endsWith(page));

        this.setIsPDP();

        this.setState({
            isVisible
        });
    }

    setIsPDP() {
        const { location: { pathname } } = history;
        const { urlType, isFooterBootomSpaceNeeded } = this.props;
        const { isPDP } = this.state;

        if (!isPDP && urlType === TYPE_PRODUCT && pathname.match(/.html/) && isFooterBootomSpaceNeeded) {
            this.setState({
                isPDP: true
            });
        }

        if (isPDP && (urlType !== TYPE_PRODUCT || !pathname.match(/.html/) || !isFooterBootomSpaceNeeded)) {
            this.setState({
                isPDP: false
            });
        }
    }

    renderNewsletter() {
        const store = getStore();
        const { ConfigReducer: { isSubscriptionBlockActive } } = store.getState();

        if (isSubscriptionBlockActive) {
            return (
                <SubscriptionBlockForm isFooter />
            );
        }

        return (
            <Subscription />
        );
    }

    renderExpandableContent(attributes, children) {
        return (
            <ExpandableContent heading={ attributes['data-heading'] }>
                { children }
            </ExpandableContent>
        );
    }

    renderStoreSwitcher() {
        return (
            <ChooseLanguageSelector isFooter />
        );
    }

    renderYear() {
        return (
            <span block="Footer" elem="Year">
                { (new Date()).getFullYear() }
            </span>
        );
    }

    renderContent() {
        const { footer_content: { footer_cms } = {} } = window.contentConfiguration;
        const { isVisible, isPDP } = this.state;

        if (!isVisible) {
            return null;
        }

        if (footer_cms) {
            return (
                <div block="Footer" mods={ { isPDP } }>
                    <CmsBlock
                      identifier={ footer_cms }
                      customComponents={ this.customComponents }
                      setIsLoading={ this.handleLoading }
                    />
                </div>
            );
        }

        return null;
    }

    renderPlaceholder() {
        const { isVisible } = this.state;

        if (!isVisible) {
            return null;
        }

        return (
            <div block="Footer" elem="PlaceholderFooterContainer">
                <div block="Footer" elem="PlaceholderFooter">
                    <div block="Footer" elem="PlaceholderTop">
                        <span block="Footer" elem="PlaceholderLogo" />
                        <span block="Footer" elem="PlaceholderSubscription" />
                    </div>
                    <div block="Footer" elem="PlaceholderMiddle">
                        <div block="Footer" elem="PlaceholderNavigation">
                            <span block="Footer" elem="PlaceholderExpandableContent" />
                            <span block="Footer" elem="PlaceholderExpandableContent" />
                            <span block="Footer" elem="PlaceholderExpandableContent" />
                            <span block="Footer" elem="PlaceholderExpandableContent" />
                        </div>
                        <div block="Footer" elem="PlaceholderSocials">
                            <div block="Footer" elem="PlaceholderIcons">
                                <span block="Footer" elem="PlaceholderIcon" />
                                <span block="Footer" elem="PlaceholderIcon" />
                                <span block="Footer" elem="PlaceholderIcon" />
                                <span block="Footer" elem="PlaceholderIcon" />
                            </div>
                            <span block="Footer" elem="PlaceholderFeatured" />
                        </div>
                    </div>
                    <div block="Footer" elem="PlaceholderBottom">
                        <span block="Footer" elem="PlaceholderLanguage" />
                        <span block="Footer" elem="PlaceholderCopyright" />
                        <span block="Footer" elem="PlaceholderTAC" />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { isLoading, isHeaderAndFooterHidden } = this.props;

        if (isHeaderAndFooterHidden) {
            return null;
        }

        if (isLoading) {
            return this.renderPlaceholder();
        }

        return this.renderContent();
    }
}

export default FooterComponent;
